module.exports = __webpack_public_path__ + "static/media/10d.4ccad051.png";